


































import { RoleType } from '@/helper/enum';
import { Component } from 'vue-property-decorator';
import { DealAttachmentJson } from '@/models/filebunker/deal';
import { AttachmentViewModel } from '@/models/fixedops/attachment';
import { FileViewModel } from '@/models/telephony/message';
import { Base } from '@/components/common/base';
import { VHeaders, VAction } from '@/models/pagedlistmodel';
import { IDialogOption } from '@/models/dialog';
import {
  attachmentTypeService,
  vehicleInventoryService,
  attachmentService,
  expenseService,
} from '@/shared';
import { FileSize } from '@/helper/enum';
import { FileUploadDataViewModel } from '@/Alynk.dtos';
import { IFileUploaderOption } from '@/models/fileUploader';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    pages() {
      return this.pagedDeals.totalPages;
    },
  },
  components: {
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})
export default class VehicleAttachmentsPage extends Base {
  public vehicleId: number = 0;
  public attachments: DealAttachmentJson[] = [];
  public loading: boolean = false;
  public attachmentId: string = '';
  public isPublic: boolean = false;
  public vehicleAttachmentLoader: boolean = false;
  public uploadBtnLoading: boolean = false;

  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        'vehicleAttachment.gridHeaders.attachmentType'
      ) as string,
      align: 'left',
      value: 'attachmentTypeName',
      sortable: false,
    },
    {
      text: this.$parent.$t(
        'vehicleAttachment.gridHeaders.uploadedAt'
      ) as string,
      align: 'left',
      value: 'createdAt',
      sortable: false,
      fieldType: 'date',
    },
    {
      text: this.$parent.$t('vehicleAttachment.gridHeaders.comments') as string,
      align: 'left',
      value: 'comment',
      sortable: false,
    },
    {
      text: this.$parent.$t('vehicleAttachment.gridHeaders.isPublic') as string,
      align: 'left',
      value: 'isPublic',
      sortable: false,
      fieldType: 'switch',
      onChange: (item: DealAttachmentJson): void => {
        this.toggleIsPublic(item);
      },
      title: (item: any): string => {
        return item.isPublic ? 'Public' : 'Not Public';
      },
      disabled: (item: DealAttachmentJson): boolean => {
        return (
          item.attachmentTypeName === 'Deal Document' ||
          item.attachmentTypeName === 'File Bunker'
        );
      },
    },
    {
      text: this.$parent.$t('vehicleAttachment.gridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public commentText: string = '';
  public commentDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t(
      'vehicleAttachment.commentDialog.addTitle'
    ) as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'vehicleAttachment.commentDialog.lblSave'
      ) as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };

  public editDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('vehicleAttachment.editDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-edit',
      text: this.$parent.$t('vehicleAttachment.editDialog.lblUpdate') as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };
  public attachmentTypes: any = [];
  public selectedAttachmentType: string = '';
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = '';
  public dragging: boolean = false;
  public attachmentFiles: FileViewModel[] = [];
  public disableUploadButton: boolean = false;
  public fileUploderRef: string = "vehicleInventoryAttachment";

  public actions: VAction[] = [
    {
      type: 'button',
      icon: 'fas fa-trash',
      color: 'error',
      title: "Delete",
      visible: () => {
        return this.isAuthorizedToAccess([RoleType.DeleteScannedAttachment]);
      },
      action: (model: AttachmentViewModel) => {
        this.deleteAttachment(model.attachmentId, model.uri);
      },
    },
    {
      type: 'button',
      icon: 'fas fa-eye',
      title: this.$parent.$t(
        'vehicleAttachment.gridHeaders.gridAction.viewAttachments'
      ) as string,
      loading: false,
      action: (model: AttachmentViewModel, action: VAction) => {
        this.openAttachment(model.attachmentId, action);
      },
    },
    {
      type: 'button',
      icon: 'fas fa-edit',
      title: this.$parent.$t(
        'vehicleAttachment.gridHeaders.gridAction.attachmentType'
      ) as string,
      action: (model: AttachmentViewModel) => {
        this.showEditDialog(model.attachmentId);
      },
    },
    {
      type: 'button',
      icon: 'fa fa-sticky-note',
      title: this.$parent.$t(
        'vehicleAttachment.gridHeaders.gridAction.comment'
      ) as string,
      action: (model: AttachmentViewModel) => {
        this.showCommentDialog(model.attachmentId);
      },
    },
  ];
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
  };
  public async deleteAttachment(attachmentId: string, uri: string): Promise<void> {
    try {
      this.loading = true;
      const fullUri = Utils.blobBasePath + uri;
      await expenseService.deleteAttachmentByUriAndId(
        attachmentId,
        fullUri,
        true
      );

      await this.getAttachments(this.vehicleId);

    } catch (e) {
      this.showAlert(false, "Error deleting attachment");
    } finally {
      this.loading = false;
    }
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName === 'upload') {
      this.UploadAttachment();
    }

    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('vehicleAttachment.btnBackToList') as string,
      disaled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('vehicleAttachment.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vehicles');

    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.vehicleId = Number(this.$route.params.vehicleId);
    this.getAttachments(this.vehicleId);
    this.getAttachmentTypes();
  }

  public async getAttachmentTypes(): Promise<void> {
    const response = await attachmentTypeService.getAttachmentTypes();
    this.attachmentTypes = response.results;
  }

  public async getAttachments(vehicleId: number): Promise<void> {
    try {
      this.loading = true;
      const response = await vehicleInventoryService.getAttachmentsAsync(
        vehicleId
      );
      this.attachments = response.results;
    } catch (e) {
      this.showAlert(
        false,
        this.$t('vehicleAttachment.alertGettingAttachment')
      );
    } finally {
      this.loading = false;
    }
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({
        name: 'app.vehicleinventory',
      });
    }
  }

  public async openAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      this.vehicleAttachmentLoader = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
      this.vehicleAttachmentLoader = false;
    }
  }

  public handleSuccess(response, file, fileList) {
    if (response === 'success') {
      this.getAttachments(this.vehicleId);
      this.showAlert(true, this.$t('vehicleAttachment.alertFileUploaded'));
    } else {
      this.showAlert(false, response);
    }
  }

  public showCommentDialog(attachmentId: string): void {
    this.selectedAttachmentType = '';
    this.commentText = '';
    this.commentDialog.model = true;
    this.attachmentId = attachmentId;
    const data = this.attachments.filter((item) => {
      if (item.attachmentId === attachmentId) {
        return item;
      }
    });
    if (data.length > 0) {
      this.commentText = data[0].comment;
    }

    if (this.commentText !== '' && this.commentText != null) {
      this.commentDialog.title = this.$parent.$t(
        'vehicleAttachment.commentDialog.editTitle'
      ) as string;
    } else {
      this.commentDialog.title = this.$parent.$t(
        'vehicleAttachment.commentDialog.addTitle'
      ) as string;
    }
  }

  public async updateAttachmentType(): Promise<void> {
    if (this.validateForm()) {
      if (this.commentDialog.model == true) {
        if (this.commentText == undefined || this.commentText == '') {
          this.showAlert(false, 'Please add comment value');
          return;
        }
      }

      if (this.editDialog.model == true) {
        if (this.selectedAttachmentType == '') {
          // this.showAlert(false, 'Please select Attachment Type');
          return;
        }
      }

      try {
        this.editDialog.loading = true;
        this.commentDialog.loading = true;
        await vehicleInventoryService.updateAttachmentAsync(
          this.attachmentId,
          this.selectedAttachmentType,
          this.commentText
        );
        await this.getAttachments(this.vehicleId);
      } catch (e) {
        this.showAlert(false, this.$t('vehicleAttachment.alertErrorOccurred'));
        console.log(e);
      } finally {
        this.editDialog.loading = false;
        this.commentDialog.loading = false;
        this.commentDialog.model = false;
        this.editDialog.model = false;
      }
    }
  }

  public showEditDialog(attachmentId: string): void {
    this.editDialog.model = true;
    this.attachmentId = attachmentId;
    this.commentText = '';
  }

  public async UploadAttachment() {
    if (this.attachmentFiles.length > 0) {
      try {
        this.disableUploadButton = true;
        this.$emit('update:progress', this.disableUploadButton);
        await vehicleInventoryService.uploadFileAsync(
          this.vehicleId,
          this.isPublic,
          this.attachmentFiles
        );
        this.showAlert(
          true,
          this.$t('vehicleAttachment.alertAttachmentUploaded')
        );

        this.attachmentFiles = [];
        this.selectedFiles = '';
        this.files = [];
        await this.getAttachments(this.vehicleId);
      } finally {
        this.disableUploadButton = false;
        this.$emit('update:progress', this.disableUploadButton);
        this.$root.$emit('resetFileList', this.fileUploderRef);
      }
    }
    else {
      this.showAlert(false, this.$t('vehicleReviveAttachment.alertSelectFileForUpload'));
    }
  }

  public toggleIsPublic(item: any): void {
    if (item.isPublic) {
      this.togglePublic(item.attachmentId, true);
    } else {
      this.togglePublic(item.attachmentId, false);
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    try {
      await attachmentService.toggleIsPublicAsync(id, status);
      this.showAlert(true, this.$t('vehicleAttachment.alertAttachmentUpdated'));
    } finally {
      this.hideLoader();
    }
  }

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }
}
